module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/156-costa-rica-062dec7b5152fb6521e36cd64dda67f8.svg";